// NAV

var fn_navigation_rwd = function () {

    var $el = $("#nav-primary__wrapper");
    $el.on('show.bs.dropdown', function () {
        // do something...
        // console.log('MegaNav opening !');
        $('body').addClass('nav-is-open');
    })
    $el.on('hide.bs.dropdown', function () {
        // do something...
        // console.log('MegaNav closing !');
        $('body').removeClass('nav-is-open');
    })

}